import { render, staticRenderFns } from "./DeviceOrderItem.vue?vue&type=template&id=f42ad538&"
import script from "./DeviceOrderItem.vue?vue&type=script&lang=js&"
export * from "./DeviceOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../order-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports